import repository from "@/plugins/axios/secureClient";

const resource = "filters";

export default {
  getAllUsersForFilter() {
    return repository.get(`${resource}/users/`);
  },
  getAllGroupsForFilter() {
    return repository.get(`${resource}/groups/`);
  },
  getFilters(routeName) {
    return repository.get(`${resource}`, { params: { route: routeName } });
  },
  createFilter(data) {
    return repository.post(`${resource}`, data);
  },
  addFavorite({ id }) {
    return repository.post(`${resource}/${id}/favorite`);
  },
  deleteFavorite({ route }) {
    return repository.post(`${resource}/unfavorite`, { route });
  },
  deleteFilter(id) {
    return repository.delete(`${resource}/${id}`);
  }
};
